module.exports = __webpack_public_path__ + "static/media/kechexiao1.20fe2538.png";